import { Component, OnInit, OnDestroy, Input, ChangeDetectorRef, ViewRef, ChangeDetectionStrategy } from '@angular/core';
import { FieldType } from "@ngx-formly/core";
import { AppStateService } from "src/app/core-module/services/app-state.service";
import { AloAocStateService } from "../../../core-module/services/state/alo-aoc-state.service";
import { FeatureDataStateService } from "../../../core-module/services/state/feature-data-state.service";
import { FeatureDefaultsStateService } from "../../../core-module/services/state/feature-defaults-state.service";
@Component({
  standalone: false,
  selector: "app-corridor",
  templateUrl: "./corridor.component.html",
  styleUrls: ["./corridor.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CorridorComponent extends FieldType implements OnInit, OnDestroy {
  @Input() field;
  column: LegacyAny;
  properties: LegacyAny;
  ngModelval: LegacyAny = {};
  inputError: LegacyAny = [];
  quickConfigvalue: boolean;
  quickConfigCustomCSS: string;
  setQuickConfig: string;
  corridorNormal;
  corridorNormalMin;
  corridorNormalMax;
  NormalLevelValue;
  corridorNormalOption;
  corridorBackgroundLevel: LegacyAny;
  corridorBackgroundLevelMin: LegacyAny;
  corridorBackgroundLevelMax: LegacyAny;
  BackgroundLevelValue: LegacyAny;
  corridorBackgroundLevelOption: { floor: LegacyAny; ceil: LegacyAny };
  corridorDelayTime: LegacyAny;
  corridorDelayTimeMin: LegacyAny;
  corridorDelayTimeMax: LegacyAny;
  DelayTimeValue: LegacyAny;
  corridorDelayTimeOption: { floor: LegacyAny; ceil: LegacyAny };
  corridorFadeTimeIndexMin: LegacyAny;
  corridorFadeTimeIndex: LegacyAny;
  corridorFadeTimeIndexMax: LegacyAny;
  FadeTimeIndexValue: LegacyAny;
  corridorFadeTimeIndexOption: { floor: LegacyAny; ceil: LegacyAny };
  corridorProlongTime: LegacyAny;
  corridorProlongTimeMin: LegacyAny;
  corridorProlongTimeMax: LegacyAny;
  prolongTimeInfiniteValue: LegacyAny = 2550;
  ProlongTimeValue: LegacyAny;
  corridorProlongTimeOption: { floor: LegacyAny; ceil: LegacyAny };
  corridorActivationTime: LegacyAny;
  corridorActivationTimeMin: LegacyAny;
  corridorActivationTimeMax: LegacyAny;
  ActivationTimeValue: LegacyAny;
  corridorActivationTimeOption: { floor: LegacyAny; ceil: LegacyAny };
  InfiniteDisabledVal;
  corridorDefaultColor;
  corridordisbaled: boolean;
  corridorCreateFile: boolean;
  corridorEnabledval: LegacyAny;
  isEdited: LegacyAny;
  calculatedPercentageVal = null;
  calculatedPercentageVal1 = null;
  fadeTimeDynamicVal: LegacyAny;
  fadeTimeDataset = {
    "0": "Extended fade",
    "1": "0.7",
    "2": "1.0",
    "3": "1.4",
    "4": "2.0",
    "5": "2.8",
    "6": "4.0",
    "7": "5.7",
    "8": "8.0",
    "9": "11.3",
    "10": "16.0",
    "11": "22.6",
    "12": "32.0",
    "13": "45.3",
    "14": "64.0",
    "15": "90.5",
  };
  isExternalRset: LegacyAny;
  constructor(
    private ref: ChangeDetectorRef, private appState: AppStateService,
    private featureData: FeatureDataStateService,
    private featureDefaults: FeatureDefaultsStateService,
    private aloAoc: AloAocStateService
  ) {
    super();
  }

  ngOnInit() {
    this.isEdited = false;
    this.featureData.getCorridorGraphData.subscribe((responseGraph) => {
      if (!responseGraph) {
        return;
      }
      this.ngModelval["ActivationTimeValue"] =
        responseGraph["ActivationTimeValue"];
      this.ngModelval["BackgroundLevelValue"] = this.BackgroundLevelValue =
        responseGraph["BackgroundLevelValue"];
      if (
        this.BackgroundLevelValue >= this.corridorBackgroundLevelMin &&
        !this.inputError["BackgroundLevel"]
      ) {
        const y = (this.BackgroundLevelValue - 1) / (253 / 3) - 1;
        this.calculatedPercentageVal1 = Math.round(Math.pow(10, y));
      } else {
        this.calculatedPercentageVal1 = null;
      }
      this.ngModelval["CorridorEnabled"] = this.corridorEnabledval =
        responseGraph["CorridorEnabled"];
      this.ngModelval["DelayTimeValue"] = this.DelayTimeValue =
        responseGraph["DelayTimeValue"];
      this.ngModelval["FadeTimeIndexValue"] = this.FadeTimeIndexValue =
        responseGraph["FadeTimeIndexValue"];
      this.fadeTimeDynamicVal =
        this.fadeTimeDataset[responseGraph["FadeTimeIndexValue"]];
      this.ngModelval["NormalLevelValue"] = this.NormalLevelValue =
        responseGraph["NormalLevelValue"];
      if (
        this.NormalLevelValue >= this.corridorNormalMin &&
        !this.inputError["NormalLevel"]
      ) {
        const y = (this.NormalLevelValue - 1) / (253 / 3) - 1;
        this.calculatedPercentageVal = Math.round(Math.pow(10, y));
      } else {
        this.calculatedPercentageVal = null;
      }
      this.ngModelval["ProlongTimeValue"] = this.ProlongTimeValue =
        responseGraph["ProlongTimeValue"];
      this.InfiniteDisabledVal = this.ngModelval["infiniteDisabled"] =
        responseGraph["infiniteDisabled"];
      //fixed graph drag issue
      this.corridorActivationTimeChange(this.ngModelval["ActivationTimeValue"]);
      // Validate ranges after graph update to ensure out-of-range indicators are preserved
      this.validateOutOfRangeValues();
    });
    this.featureDefaults.getCorridorDefault.subscribe((response) => {
      if (response) {
        this.corridorDefaultColor = true;
        this.resetDefaultCorridor();
      }
    });

    // Guard: If schema not loaded, initialize with safe defaults and return
    if (!this.field || !this.field.properties || !this.field.requiredProperties) {
      this.corridorNormalOption = { floor: 0, ceil: 254 };
      this.corridorBackgroundLevelOption = { floor: 0, ceil: 254 };
      this.corridorDelayTimeOption = { floor: 0, ceil: 100 };
      this.corridorFadeTimeIndexOption = { floor: 0, ceil: 100 };
      return;
    }

    ///From API
    this.column = this.field.requiredProperties;
    this.properties = this.field.properties;
    this.featureData.corridorInputError(false);
    ///Begining of corridorNormal
    this.corridorNormal = this.properties.NormalLevel;
    this.corridorNormalMin = this.corridorNormal.minimum;
    this.corridorNormalMax = this.corridorNormal.maximum;
    this.ngModelval["NormalLevelValue"] = this.NormalLevelValue =
      this.corridorNormal.default;
    this.ngModelval["NormalLevelMaximum"] = this.corridorNormalMax;
    this.corridorNormalOption = {
      floor: this.corridorNormalMin,
      ceil: this.corridorNormalMax,
    };
    if (
      this.NormalLevelValue >= this.corridorNormalMin &&
      !this.inputError["NormalLevel"]
    ) {
      const y = (this.NormalLevelValue - 1) / (253 / 3) - 1;
      this.calculatedPercentageVal = Math.round(Math.pow(10, y));
    } else {
      this.calculatedPercentageVal = null;
    }
    //End of corridorNormal
    ///Begining of BackgroundLevel
    this.corridorBackgroundLevel = this.properties.BackgroundLevel;
    this.corridorBackgroundLevelMin = this.corridorBackgroundLevel.minimum;
    this.corridorBackgroundLevelMax = this.corridorBackgroundLevel.maximum;
    this.ngModelval["BackgroundLevelValue"] = this.BackgroundLevelValue =
      this.corridorBackgroundLevel.default;
    this.ngModelval["BackgroundLevelMaximum"] = this.corridorBackgroundLevelMax;
    this.corridorBackgroundLevelOption = {
      floor: this.corridorBackgroundLevelMin,
      ceil: this.corridorBackgroundLevelMax,
    };
    if (
      this.BackgroundLevelValue >= this.corridorBackgroundLevelMin &&
      !this.inputError["BackgroundLevel"]
    ) {
      const y = (this.BackgroundLevelValue - 1) / (253 / 3) - 1;
      this.calculatedPercentageVal1 = Math.round(Math.pow(10, y));
    } else {
      this.calculatedPercentageVal1 = null;
    }
    //End of BackgroundLevel
    ///Begining of DelayTime
    this.corridorDelayTime = this.properties.DelayTime;
    this.corridorDelayTimeMin = this.corridorDelayTime.minimum;
    this.corridorDelayTimeMax = this.corridorDelayTime.maximum;
    this.ngModelval["DelayTimeValue"] = this.DelayTimeValue =
      this.corridorDelayTime.default;
    this.corridorDelayTimeOption = {
      floor: this.corridorDelayTimeMin,
      ceil: this.corridorDelayTimeMax,
    };
    //End of DelayTime
    ///Begining of FadeTimeIndex
    this.corridorFadeTimeIndex = this.properties.FadeTimeIndex;
    this.corridorFadeTimeIndexMin = this.corridorFadeTimeIndex.minimum;
    this.corridorFadeTimeIndexMax = this.corridorFadeTimeIndex.maximum;
    this.ngModelval["FadeTimeIndexValue"] = this.FadeTimeIndexValue =
      this.corridorFadeTimeIndex.default;
    this.fadeTimeDynamicVal =
      this.fadeTimeDataset[this.corridorFadeTimeIndex.default];
    this.ngModelval["FadeTimeIndexMaximum"] = this.corridorFadeTimeIndexMax;
    this.corridorFadeTimeIndexOption = {
      floor: this.corridorFadeTimeIndexMin,
      ceil: this.corridorFadeTimeIndexMax,
    };
    //End of FadeTimeIndex
    ///Begining of ProlongTime
    this.corridorProlongTime = this.properties.ProlongTime;
    this.corridorProlongTimeMin =
      this.field.oneOf[0].properties.ProlongTime.minimum;
    this.corridorProlongTimeMax =
      this.field.oneOf[0].properties.ProlongTime.maximum;
    this.prolongTimeInfiniteValue = this.getProlongTimeInfiniteValue();
    this.ngModelval["ProlongTimeValue"] = this.ProlongTimeValue =
      this.corridorProlongTime.default;
    this.corridorProlongTimeOption = {
      floor: this.corridorProlongTimeMin,
      ceil: this.corridorProlongTimeMax,
    };
    //End of ProlongTime
    ///Begining of ActivationTime
    this.corridorActivationTime = this.properties.ActivationTime;
    this.corridorActivationTimeMin = this.corridorActivationTime.minimum;
    this.corridorActivationTimeMax = this.corridorActivationTime.maximum;
    this.ngModelval["ActivationTimeValue"] = this.ActivationTimeValue =
      this.corridorActivationTime.default;
    this.corridorActivationTimeOption = {
      floor: this.corridorActivationTimeMin,
      ceil: this.corridorActivationTimeMax,
    };
    //End of ActivationTime
    //DTL enabled start
    if (
      this.properties["CorridorEnabled"] &&
      this.properties["CorridorEnabled"].default
    ) {
      this.corridorEnabledval = this.properties["CorridorEnabled"].default;
      this.ngModelval["CorridorEnabled"] =
        this.properties["CorridorEnabled"].default;
      //this.rSetChanged(this.DtlEnabledval);
    }
    //end DTL Enabled
    this.InfiniteDisabledVal = this.ngModelval["infiniteDisabled"] = false;
    //For quick Configuration
    this.aloAoc.getquickConfig.subscribe((data) => {
      if (data === "quickConfig") {
        this.quickConfigvalue = true;
        this.quickConfigCustomCSS = "quick-custom-inputbox textBoxUnit";
        this.setQuickConfig = "quickConfig";
      } else if (data === "standard") {
        this.quickConfigvalue = false;
        this.quickConfigCustomCSS = "custom-inputbox";
        this.setQuickConfig = "standard";
      }
      setTimeout(() => {
        if (this.ref && !(this.ref as ViewRef).destroyed) {
          this.ref.detectChanges();
        }
      });
    });
    ///End quick config
    const unSelectedFeat = this.appState.getUnSelectedFeatConfig();
    let isConfigEdited = false;
    let featIndex: number = 0;
    if (unSelectedFeat != null) {
      unSelectedFeat.forEach((element) => {
        if (element["featureName"].toString().toUpperCase() === "CORRIDOR") {
          isConfigEdited = true;
          const CORRIDOR: LegacyAny = element["featureParameters"][0];
          this.addCorridorLoadedFeatureReadValues(CORRIDOR);
          unSelectedFeat.splice(featIndex, 1);
          this.appState.setUnSelectedFeatConfig(unSelectedFeat);
        } else {
          featIndex++;
        }
      });
    }

    if (!isConfigEdited) {
      // Use centralized method to get feature data
      // This automatically prioritizes SaveSetData over ConfigurationData
      const corridorData = this.appState.getFeatureData('Corridor');
      if (corridorData) {
        this.addCorridorLoadedFeatureReadValues(corridorData);
      }
    }

    this.checkdfault();
    this.sendCorridordata(this.ngModelval);
    this.isEdited = true;
  }
  addCorridorLoadedFeatureReadValues(Corridor: LegacyAny) {
    const CorridorObj = Corridor;
    const keys = Object.keys(CorridorObj);
    const values = Object.values(CorridorObj);
    keys.forEach((key, i) => {
      const value = key === "ProlongTime" && values[i] === 2550 ? 2540 : values[i];
      this.textValChanged(value, key);
    });
    const index = keys.indexOf("ActivationTime");
    keys[index] = "ActivationTimeValue";
    const index1 = keys.indexOf("BackgroundLevel");
    keys[index1] = "BackgroundLevelValue";
    const index2 = keys.indexOf("DelayTime");
    keys[index2] = "DelayTimeValue";
    const index3 = keys.indexOf("FadeTimeIndex");
    keys[index3] = "FadeTimeIndexValue";
    const index4 = keys.indexOf("NormalLevel");
    keys[index4] = "NormalLevelValue";
    const index5 = keys.indexOf("ProlongTime");
    keys[index5] = "ProlongTimeValue";
    const result: LegacyAny = {};
    keys.forEach((key, i) => (result[key] = values[i]));
    this.ngModelval = result;
    this.ngModelval["CorridorEnabled"] = result["CorridorEnabled"];
    this.corridordisbaled = !this.ngModelval["CorridorEnabled"];
    this.corridorNormal = this.properties.NormalLevel;
    this.corridorNormalMin = this.corridorNormal.minimum;
    this.corridorNormalMax = this.corridorNormal.maximum;
    this.ngModelval["NormalLevelValue"] = this.NormalLevelValue =
      result["NormalLevelValue"];
    this.ngModelval["NormalLevelMaximum"] = this.corridorNormalMax;
    this.corridorNormalOption = {
      floor: this.corridorNormalMin,
      ceil: this.corridorNormalMax,
    };
    this.corridorBackgroundLevel = this.properties.BackgroundLevel;
    this.corridorBackgroundLevelMin = this.corridorBackgroundLevel.minimum;
    this.corridorBackgroundLevelMax = this.corridorBackgroundLevel.maximum;
    this.ngModelval["BackgroundLevelValue"] = this.BackgroundLevelValue =
      result["BackgroundLevelValue"];
    this.ngModelval["BackgroundLevelMaximum"] = this.corridorBackgroundLevelMax;
    this.corridorBackgroundLevelOption = {
      floor: this.corridorBackgroundLevelMin,
      ceil: this.corridorBackgroundLevelMax,
    };
    this.corridorDelayTime = this.properties.DelayTime;
    this.corridorDelayTimeMin = this.corridorDelayTime.minimum;
    this.corridorDelayTimeMax = this.corridorDelayTime.maximum;
    this.ngModelval["DelayTimeValue"] = this.DelayTimeValue =
      result["DelayTimeValue"];
    this.corridorDelayTimeOption = {
      floor: this.corridorDelayTimeMin,
      ceil: this.corridorDelayTimeMax,
    };
    this.corridorFadeTimeIndex = this.properties.FadeTimeIndex;
    this.corridorFadeTimeIndexMin = this.corridorFadeTimeIndex.minimum;
    this.corridorFadeTimeIndexMax = this.corridorFadeTimeIndex.maximum;
    this.ngModelval["FadeTimeIndexValue"] = this.FadeTimeIndexValue =
      result["FadeTimeIndexValue"];
    this.ngModelval["FadeTimeIndexMaximum"] = this.corridorFadeTimeIndexMax;
    this.corridorFadeTimeIndexOption = {
      floor: this.corridorFadeTimeIndexMin,
      ceil: this.corridorFadeTimeIndexMax,
    };
    this.corridorProlongTime = this.properties.ProlongTime;
    this.corridorProlongTimeMin =
      this.field.oneOf[0].properties.ProlongTime.minimum;
    this.corridorProlongTimeMax =
      this.field.oneOf[0].properties.ProlongTime.maximum;
    this.ngModelval["ProlongTimeValue"] = this.ProlongTimeValue =
      result["ProlongTimeValue"];
    this.corridorProlongTimeOption = {
      floor: this.corridorProlongTimeMin,
      ceil: this.corridorProlongTimeMax,
    };
    this.corridorActivationTime = this.properties.ActivationTime;
    this.corridorActivationTimeMin = this.corridorActivationTime.minimum;
    this.corridorActivationTimeMax = this.corridorActivationTime.maximum;
    this.ngModelval["ActivationTimeValue"] = this.ActivationTimeValue =
      result["ActivationTimeValue"];
    this.corridorActivationTimeOption = {
      floor: this.corridorActivationTimeMin,
      ceil: this.corridorActivationTimeMax,
    };
    if (
      result["ProlongTimeValue"] === this.prolongTimeInfiniteValue ||
      result["infiniteDisabled"] === true
    ) {
      this.ngModelval["infiniteDisabled"] = this.InfiniteDisabledVal = true;
      this.ngModelval["ProlongTimeValue"] = this.corridorProlongTimeMax;
      this.inputError["ProlongTime"] = false;
    } else if (
      result["ProlongTimeValue"] != this.prolongTimeInfiniteValue ||
      result["infiniteDisabled"] === false
    ) {
      this.ngModelval["infiniteDisabled"] = this.InfiniteDisabledVal = false;
    }
    this.infinteDisabled(this.ngModelval["infiniteDisabled"]);
    this.validateOutOfRangeValues();
    this.checkdfault();
    this.sendCorridordata(this.ngModelval);
  }
  sendCorridordata(val) {
    this.featureData.sendCorridordata(val);
    if (this.isEdited) {
      this.setConfigurationData(val, "Corridor");
    }
  }

  // Infinite lives in a separate `oneOf` branch of the schema, as a ProlongTime const.
  private getProlongTimeInfiniteValue() {
    const branches: LegacyAny[] = this.field?.oneOf ?? [];
    const infiniteBranch = branches.find(
      (branch) => branch?.properties?.ProlongTime?.const !== undefined
    );
    return infiniteBranch?.properties?.ProlongTime?.const ?? 2550;
  }
  rSetChanged(value) {
    this.corridorDefaultColor = value;
    for (let i = 0; i < this.column.length; i++) {
      const type = this.column[i];
      if (this.ngModelval[type] != this.properties[type]["default"]) {
        this.corridorDefaultColor = false;
      }
    }
    this.ngModelval["CorridorEnabled"] = value;
    this.sendCorridordata(this.ngModelval);
    this.checkdfault();
    this.corridordisbaled = !value;
    this.featureData.corridorEditedVal(this.corridorDefaultColor);
    this.ref.detectChanges();
  }

  infinteDisabled(value) {
    this.InfiniteDisabledVal = value;
    if (value) {
      this.corridorDefaultColor = false;
      this.featureData.corridorEditedVal(this.corridorDefaultColor);
    } else {
      this.corridorDefaultColor = true;
      this.featureData.corridorEditedVal(this.corridorDefaultColor);
    }
    this.ngModelval["infiniteDisabled"] = value;
    this.sendCorridordata(this.ngModelval);
    this.checkdfault();
  }

  corridorNormalValueChange(value) {
    this.textValChanged(value, "NormalLevel");
  }
  corridorBackgroundLevelChange(value) {
    this.textValChanged(value, "BackgroundLevel");
  }
  corridorFadeTimeIndexChange(value) {
    this.textValChanged(value, "FadeTimeIndex");
  }
  corridorDelayTimeChange(value) {
    this.changeMultiples(value, "DelayTime");
  }
  corridorProlongTimeChange(value) {
    this.changeMultiples(value, "ProlongTime");
  }
  corridorActivationTimeChange(value) {
    this.textValChanged(value, "ActivationTime");
  }

  sendMaxValues() {
    this.ngModelval["FadeTimeIndexMaximum"] = this.corridorFadeTimeIndexMax;
    this.ngModelval["BackgroundLevelMaximum"] = this.corridorBackgroundLevelMax;
    this.ngModelval["NormalLevelMaximum"] = this.corridorNormalMax;
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }

  changeMultiples(event, name) {
    const column = name.replace(/Value$/, "");
    if (column !== "DelayTime" && column !== "ProlongTime") {
      return;
    }
    const minimum = column === "DelayTime" ? this.corridorDelayTimeMin : this.corridorProlongTimeMin;
    const maximum = column === "DelayTime" ? this.corridorDelayTimeMax : this.corridorProlongTimeMax;
    const value = this.isInvalidValue(event, minimum, maximum) ? event : Math.round(Number(event) / 10) * 10;
    this.textValChanged(value, column);
  }

  textValChanged(value, colName) {
    if (!["NormalLevel", "BackgroundLevel", "DelayTime", "FadeTimeIndex", "ProlongTime", "ActivationTime"].includes(colName)) {
      return;
    }
    this.sendMaxValues();
    const originalVal = value;

    if (!this.isNumericInput(originalVal)) {
      this.ngModelval[`${colName}Value`] = originalVal === "" ? null : originalVal;
      this.inputError[colName] = true;
      this.corridorCreateFile = true;
      if (colName === "NormalLevel") {
        this.calculatedPercentageVal = null;
      } else if (colName === "BackgroundLevel") {
        this.calculatedPercentageVal1 = null;
      } else if (colName === "FadeTimeIndex") {
        this.fadeTimeDynamicVal = null;
      }
      this.checkdfault();
      this.featureData.corridorEditedVal(this.corridorDefaultColor);
      this.featureData.corridorInputError(this.corridorCreateFile);
      this.sendCorridordata(this.ngModelval);
      return;
    }

    value = Number(value);
    this.corridorDefaultColor = false;
    this.inputError[colName] = false;
    this.corridorCreateFile = false;
    if (colName == "NormalLevel") {
      if (value < this.corridorNormalMin || value > this.corridorNormalMax) {
        this.inputError[colName] = true;
        this.ngModelval["NormalLevelValue"] = value;
      } else {
        this.NormalLevelValue = value;
        this.ngModelval["NormalLevelValue"] = value;
      }
      if (
        this.NormalLevelValue >= this.corridorNormalMin &&
        !this.inputError["NormalLevel"]
      ) {
        const y = (this.NormalLevelValue - 1) / (253 / 3) - 1;
        this.calculatedPercentageVal = Math.round(Math.pow(10, y));
      } else {
        this.calculatedPercentageVal = null;
      }
    } else if (colName == "BackgroundLevel") {
      if (
        value < this.corridorBackgroundLevelMin ||
        value > this.corridorBackgroundLevelMax
      ) {
        this.inputError[colName] = true;
        this.ngModelval["BackgroundLevelValue"] = value;
      } else {
        this.BackgroundLevelValue = value;
        this.ngModelval["BackgroundLevelValue"] = value;
      }
      if (
        this.BackgroundLevelValue >= this.corridorBackgroundLevelMin &&
        !this.inputError["BackgroundLevel"]
      ) {
        const y = (this.BackgroundLevelValue - 1) / (253 / 3) - 1;
        this.calculatedPercentageVal1 = Math.round(Math.pow(10, y));
      } else {
        this.calculatedPercentageVal1 = null;
      }
    } else if (colName == "DelayTime") {
      if (
        originalVal < this.corridorDelayTimeMin ||
        originalVal > this.corridorDelayTimeMax ||
        originalVal.length === 0
      ) {
        this.inputError[colName] = true;
        this.ngModelval["DelayTimeValue"] = originalVal.length === 0 ? 0 : Number(originalVal);
        if (originalVal.length <= 0) {
          this.DelayTimeValue = Number(0);
        }
      } else {
        this.DelayTimeValue = Number(originalVal);
        this.ngModelval["DelayTimeValue"] = Number(originalVal);
      }
    } else if (colName == "FadeTimeIndex") {
      if (
        originalVal < this.corridorFadeTimeIndexMin ||
        originalVal > this.corridorFadeTimeIndexMax ||
        originalVal.length === 0
      ) {
        this.inputError[colName] = true;
        this.ngModelval["FadeTimeIndexValue"] = Number(originalVal);
        if (originalVal.length <= 0) {
          this.FadeTimeIndexValue = Number(0);
        }
        this.fadeTimeDynamicVal = null;
      } else {
        this.FadeTimeIndexValue = Number(originalVal);
        this.ngModelval["FadeTimeIndexValue"] = Number(originalVal);
        this.fadeTimeDynamicVal = this.fadeTimeDataset[originalVal];
      }
      // if (value < this.corridorFadeTimeIndexMin && value !== this.corridorFadeTimeIndex) {
      //   this.FadeTimeIndexValue = this.corridorFadeTimeIndexMin;
      // } else if(value > this.corridorFadeTimeIndexMax && value !== this.corridorFadeTimeIndex){
      //   this.FadeTimeIndexValue = this.corridorFadeTimeIndexMax;
      // }else{
      //   this.FadeTimeIndexValue = value;
      // }
    } else if (colName == "ProlongTime") {
      if (
        originalVal < this.corridorProlongTimeMin ||
        originalVal > this.corridorProlongTimeMax ||
        originalVal.length === 0
      ) {
        this.inputError[colName] = true;
        this.ngModelval["ProlongTimeValue"] = originalVal.length === 0 ? 0 : Number(originalVal);
        if (originalVal.length <= 0) {
          this.ProlongTimeValue = Number(0);
        }
      } else {
         this.ProlongTimeValue = Number(originalVal);
         this.ngModelval["ProlongTimeValue"] = Number(originalVal);
      }
    } else if (colName == "ActivationTime") {
      if (
        originalVal < this.corridorActivationTimeMin ||
        originalVal > this.corridorActivationTimeMax ||
        originalVal.length === 0
      ) {
        this.inputError[colName] = true;
        this.ngModelval["ActivationTimeValue"] = originalVal;
        if (originalVal.length <= 0) {
          this.ActivationTimeValue = Number(0);
        }
      } else {
        this.ActivationTimeValue = Number(originalVal);
        this.ngModelval["ActivationTimeValue"] = Number(originalVal);
      }
    }
    this.checkdfault();
    for (const type in this.inputError) {
      if (this.inputError[type]) {
        this.corridorCreateFile = true;
      }
    }
    this.featureData.corridorEditedVal(this.corridorDefaultColor);
    this.featureData.corridorInputError(this.corridorCreateFile);
    this.sendCorridordata(this.ngModelval);
  }

  checkInvalidValues() {
    this.corridorCreateFile = false;
    for (const type in this.inputError) {
      if (this.inputError[type]) {
        this.corridorCreateFile = true;
      }
    }
    this.featureData.corridorInputError(this.corridorCreateFile);
  }

  /**
   * Validates all corridor values against their min/max ranges after loading.
   * Sets inputError flags for out-of-range values and ensures the actual
   * device values are preserved in ngModelval for display (not reset to defaults).
   */
  validateOutOfRangeValues() {
    // NormalLevel
    const normalVal = this.ngModelval["NormalLevelValue"];
    if (this.isInvalidValue(normalVal, this.corridorNormalMin, this.corridorNormalMax)) {
      this.inputError["NormalLevel"] = true;
      this.calculatedPercentageVal = null;
    }
    // BackgroundLevel
    const bgVal = this.ngModelval["BackgroundLevelValue"];
    if (this.isInvalidValue(bgVal, this.corridorBackgroundLevelMin, this.corridorBackgroundLevelMax)) {
      this.inputError["BackgroundLevel"] = true;
      this.calculatedPercentageVal1 = null;
    }
    // DelayTime
    const delayVal = this.ngModelval["DelayTimeValue"];
    if (this.isInvalidValue(delayVal, this.corridorDelayTimeMin, this.corridorDelayTimeMax)) {
      this.inputError["DelayTime"] = true;
    }
    // FadeTimeIndex
    const fadeVal = this.ngModelval["FadeTimeIndexValue"];
    if (this.isInvalidValue(fadeVal, this.corridorFadeTimeIndexMin, this.corridorFadeTimeIndexMax)) {
      this.inputError["FadeTimeIndex"] = true;
      this.fadeTimeDynamicVal = null;
    }
    // ProlongTime
    const prolongVal = this.ngModelval["ProlongTimeValue"];
    if (this.isInvalidValue(prolongVal, this.corridorProlongTimeMin, this.corridorProlongTimeMax)) {
      this.inputError["ProlongTime"] = true;
    }
    // ActivationTime
    const actVal = this.ngModelval["ActivationTimeValue"];
    if (this.isInvalidValue(actVal, this.corridorActivationTimeMin, this.corridorActivationTimeMax)) {
      this.inputError["ActivationTime"] = true;
    }
    // Propagate error state
    this.checkInvalidValues();
  }

  /** A cleared textbox is stored as `null`; `undefined` means the column is absent. */
  private isInvalidValue(value: LegacyAny, min: LegacyAny, max: LegacyAny): boolean {
    if (value === undefined) {
      return false;
    }
    return !this.isNumericInput(value) || (min != null && value < min) || (max != null && value > max);
  }

  private isNumericInput(value: LegacyAny): boolean {
    return (typeof value === "number" || (typeof value === "string" && /^\d+$/.test(value))) &&
      Number.isSafeInteger(Number(value));
  }

  sliderEvent(option?) {}

  resetDefaultCorridor() {
    this.ngModelval["NormalLevelValue"] = this.NormalLevelValue =
      this.corridorNormal.default;
    const y = (this.NormalLevelValue - 1) / (253 / 3) - 1;
    this.calculatedPercentageVal = Math.round(Math.pow(10, y));
    this.ngModelval["DelayTimeValue"] = this.DelayTimeValue =
      this.corridorDelayTime.default;
    this.ngModelval["FadeTimeIndexValue"] = this.FadeTimeIndexValue =
      this.corridorFadeTimeIndex.default;
    this.fadeTimeDynamicVal =
      this.fadeTimeDataset[this.corridorFadeTimeIndex.default];
    this.ngModelval["ActivationTimeValue"] = this.ActivationTimeValue =
      this.corridorActivationTime.default;
    this.ngModelval["BackgroundLevelValue"] = this.BackgroundLevelValue =
      this.corridorBackgroundLevel.default;
    const y1 = (this.BackgroundLevelValue - 1) / (253 / 3) - 1;
    this.calculatedPercentageVal1 = Math.round(Math.pow(10, y1));
    this.ngModelval["ProlongTimeValue"] = this.ProlongTimeValue =
      this.corridorProlongTime.default;
    this.ngModelval["CorridorEnabled"] =
      this.properties["CorridorEnabled"].default;
    this.corridordisbaled = !this.ngModelval["CorridorEnabled"];
    this.ngModelval["infiniteDisabled"] = false;
    this.infinteDisabled(this.ngModelval["infiniteDisabled"]);
    for (const type in this.inputError) {
      this.inputError[type] = false;
    }
    this.corridorCreateFile = false;
    this.featureData.corridorInputError(this.corridorCreateFile);
    this.sendCorridordata(this.ngModelval);
    this.ref.markForCheck();
  }

  checkdfault() {
    let newtype;
    this.corridorDefaultColor = true;
    if (this.properties != null) {
      for (const type in this.ngModelval) {
        if (
          type != "infiniteDisabled" &&
          type != "FadeTimeIndexMaximum" &&
          type != "NormalLevelMaximum" &&
          type != "BackgroundLevelMaximum" &&
          this.properties != null &&
          type != "CorridorEnabled"
        ) {
          newtype = type.replace("Value", "");
          if (this.ngModelval[type] != this.properties[newtype]["default"]) {
            this.corridorDefaultColor = false;
          }
        }
        if (
          this.properties != null &&
          type === "infiniteDisabled" &&
          this.ngModelval["infiniteDisabled"]
        ) {
          this.corridorDefaultColor = false;
        }
        if (
          this.properties && this.ngModelval[type] != null &&
          type === "CorridorEnabled"
        ) {
          if (this.ngModelval[type] != this.properties[type]["default"]) {
            this.corridorDefaultColor = false;
          }
        }
        this.featureData.corridorEditedVal(this.corridorDefaultColor);
      }
    }
  }
  setConfigurationData(value, keyVal) {
    // Use centralized method to save feature data
    // This automatically saves to both ConfigurationData and SaveSetData
    const corridorObj = Object.assign({}, value);
    this.appState.setFeatureData(keyVal, corridorObj);
  }
  ngOnDestroy() {
    this.featureData.sendCorridordata("");
    this.featureDefaults.setCorridorDefaultColor("");
    // this.featureDefaults.setCorridorDefaultColor("");
    // this.sendCorridordata("");
  }
}

